import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useWorkstations } from '@/hooks/v1';
import type { InputDefaultProps } from '../../../types';
import { FormItem } from '@/components/ui/Inputs/FormItem';
import { WorkstationSelect } from '@/components/ui/Inputs/WorkstationSelect';

const { useFormInstance, useWatch } = Form;

export function Workstation({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const form = useFormInstance();

	const organizationId = useWatch([fieldName, 'organization_id'], form);
	const companyId = useWatch([fieldName, 'company_id'], form);
	const lineId = useWatch([fieldName, 'line_id'], form);
	const workstationId = useWatch([fieldName, 'workstation_id'], form);

	const {
		data: workstations,
		isFetching,
		isLoading,
		isError
	} = useWorkstations({
		organization_id: organizationId,
		company_id: companyId,
		line_id: lineId
	});

	function handleSelectWorkstation(id: string): void {
		form.setFieldValue([fieldName, 'workstation_id'], id);
		form.setFieldValue([fieldName, 'activity_id'], undefined);
	}

	function handleClearWorkstations(): void {
		form.setFieldValue([fieldName, 'workstation_id'], undefined);
		form.setFieldValue([fieldName, 'activity_id'], undefined);
	}

	return (
		<Col xs={24}>
			<FormItem
				title={I18n.get('Workstation')}
				fontSize={fontSize}
				isRequired={isRequired}
				namePath={[fieldName, 'workstation_id']}
				errorMessage={I18n.get('Select a workstation')}
			>
				<WorkstationSelect
					size="large"
					lineId={lineId}
					loading={isFetching}
					workstations={workstations}
					workstationId={workstationId}
					fieldName={[fieldName, 'workstation_id']}
					handleSelectWorkstation={handleSelectWorkstation}
					handleClearWorkstations={handleClearWorkstations}
					disabled={isLoading || isFetching || isError || !lineId || disabled}
				/>
			</FormItem>
		</Col>
	);
}
